import React from 'react'
import { Field } from 'redux-form'
import { renderTextField } from '../../Forms/fieldRenderers'

function ConsultaPorCodigoDeCupo (props) {
  const { textLabel } = props

  return (
    <Field
      name='codigoCupo'
      style={{ padding: '0', fontSize: '1.2rem', textAlign: 'center' }}
      type='text'
      label={textLabel || 'Consultar código de cupo'}
      component={renderTextField}
      autoFocus={props.autoFocus}
      placeholder='COD222222222'
    />
  )
}

export default ConsultaPorCodigoDeCupo
